import { render, staticRenderFns } from "./ProductEmpty.vue?vue&type=template&id=5e37712c&scoped=true"
import script from "./ProductEmpty.vue?vue&type=script&lang=js"
export * from "./ProductEmpty.vue?vue&type=script&lang=js"
import style0 from "./ProductEmpty.vue?vue&type=style&index=0&id=5e37712c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37712c",
  null
  
)

export default component.exports